<template>
  <v-container>
    <v-row justify="end">
      <RequiredItemText/>
    </v-row>
    <v-row id="realName">
      <FormItem :name="label('realName')" required>
        <v-row no-gutters>
          <v-col cols="6" class="pr-1">
            <TextField
              v-model="lastName"
              name="姓"
              :max="20"
              required
              :submit="submit"
            />
          </v-col>
          <v-col cols="6" class="pl-1">
            <TextField
              v-model="firstName"
              name="名"
              :max="20"
              required
              :submit="submit"
            />
          </v-col>
        </v-row>
      </FormItem>
    </v-row>
    <v-row id="realNameKana">
      <FormItem :name="label('realNameKana')" required>
        <v-row no-gutters>
          <v-col cols="6" class="pr-1">
            <TextField
              v-model="lastNameKana"
              name="セイ"
              :max="20"
              required
              :submit="submit"
            />
          </v-col>
          <v-col cols="6" class="pl-1">
            <TextField
              v-model="firstNameKana"
              name="メイ"
              :max="20"
              required
              :submit="submit"
            />
          </v-col>
        </v-row>
      </FormItem>
    </v-row>
    <v-row id="department">
      <FormItem :name="label('department')" >
        <TextField
          v-model="department"
          :name="label('department')"
          :max="50"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="tel">
      <FormItem :name="label('tel')" required>
        <TextField
          v-model="tel"
          :name="label('tel')"
          :rules="telRules"
          noCounter
          :max="11"
          required
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row>
      <SectionTitle :title="label('addresses')"/>
    </v-row>
    <v-row id="email">
      <FormItem :name="label('email')" required>
        <TextField
            v-model="email"
            type="email"
            :name="label('email')"
            :max="100"
            noCounter
            :rules="emailRules"
            required
            :disabled="isSocial"
            :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="cc1">
      <FormItem :name="label('cc1')">
        <TextField
            v-model="cc1"
            type="email"
            :name="label('cc1')"
            :max="100"
            noCounter
            :rules="emailRules"
        />
      </FormItem>
    </v-row>
    <v-row id="cc2">
      <FormItem :name="label('cc2')">
        <TextField
            v-model="cc2"
            type="email"
            :name="label('cc2')"
            :max="100"
            noCounter
            :rules="emailRules"
        />
      </FormItem>
    </v-row>
    <v-row id="cc3">
      <FormItem :name="label('cc3')">
        <TextField
            v-model="cc3"
            type="email"
            :name="label('cc3')"
            :max="100"
            noCounter
            :rules="emailRules"
        />
      </FormItem>
    </v-row>

  </v-container>
</template>

<script>
  import TextField from "../atoms/TextField";
  import FormItem from "../molecules/FormItem";
  import RequiredItemText from "../atoms/RequiredItemText";
  import ComponentMixin from "../ComponentMixin";
  import {mapGetters} from "vuex";
  import SectionTitle from "@/components/atoms/SectionTitle";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "PersonProfileForm",
    props: {
      "value": {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        iconData: null
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      lastName: {
        get () {
          return this.value.lastName
        },
        set (value) {
          this.$emit("input", {...this.value, lastName: value})
        }
      },
      lastNameKana: {
        get () {
          return this.value.lastNameKana
        },
        set (value) {
          this.$emit("input", {...this.value, lastNameKana: value})
        }
      },
      firstName: {
        get () {
          return this.value.firstName
        },
        set (value) {
          this.$emit("input", {...this.value, firstName: value})
        }
      },
      firstNameKana: {
        get () {
          return this.value.firstNameKana
        },
        set (value) {
          this.$emit("input", {...this.value, firstNameKana: value})
        }
      },
      department: {
        get () {
          return this.value.department
        },
        set (value) {
          this.$emit("input", {...this.value, department: value})
        }
      },
      email: {
        get () {
          return this.value.email
        },
        set (value) {
          this.$emit("input", {...this.value, email: value})
        }
      },
      cc1: {
        get () {
          return this.value.emailCc1
        },
        set (value) {
          this.$emit("input", {...this.value, emailCc_1: value})
        }
      },
      cc2: {
        get () {
          return this.value.emailCc2
        },
        set (value) {
          this.$emit("input", {...this.value, emailCc_2: value})
        }
      },
      cc3: {
        get () {
          return this.value.emailCc3
        },
        set (value) {
          this.$emit("input", {...this.value, emailCc_3: value})
        }
      },
      tel: {
        get () {
          return this.value.tel
        },
        set (value) {
          this.$emit("input", {...this.value, tel: value})
        }
      },
      isSocial () {
        return this.$auth && this.$auth.user && this.$auth.user.sub && !this.$auth.user.sub.startsWith("auth0")
      },
      nameKanaRules () {
        return [
          value => {
            if (value) {
              const result = value.match(/^[ァ-ヶー\s]*$/) // eslint-disable-line
              if (!result) {
                return "全角カタカナで入力してください";
              }
            }
            return true;
          }
        ]
      },
      telRules () {
        return [
          value => {
            if (value) {
              const result = value.match(/^0\d{9,10}$/)
              if (!result) {
                return "数字のみ（ハイフン無し）の電話番号を入力ください";
              }
            }
            return true;
          }
        ]
      },
      emailRules () {
        return [
          value => {
            if (value) {
              const result = value.match( /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) // eslint-disable-line
              if (!result) {
                return "有効なメールアドレスを入力してください";
              }
            }
            return true;
          }
        ]
      },
    },
    methods: {
      submit () {
      }
    },
    components: {
      SectionTitle,
      FormItem,
      TextField,
      RequiredItemText,
    }
  }
</script>

<style scoped>

</style>
